import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface SectionRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  as?: 'div' | 'li';
}
export function SectionReveal({
  children,
  className,
  delay = 0,
  as = 'div'
}: SectionRevealProps) {
  const reduce = useReducedMotion();
  const Comp = as === 'li' ? motion.li : motion.div;
  if (reduce) {
    return <Comp className={className} data-id="element-167" data-mp="3uyng2tlthe9f">{children}</Comp>;
  }
  return <Comp initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '0px 0px -8% 0px'
  }} transition={{
    duration: 0.3,
    ease: [0.2, 0, 0, 1],
    delay: Math.min(delay, 0.24)
  }} className={className} data-id="element-168" data-mp="3uxcgl5zemso4">
      {children}
    </Comp>;
}